import type { DirectiveDescriptor } from '@mdxeditor/editor';

import { YOUTUBE_MDX_DIRECTIVE_NAME } from './youTubeMdxDirectiveConstants';
import { YouTubeMdxDirectiveEditor } from './YouTubeMdxDirectiveEditor';

export const YouTubeMdxDirectiveDescriptor: DirectiveDescriptor = {
  name: YOUTUBE_MDX_DIRECTIVE_NAME,
  testNode(node) {
    return node.name === YOUTUBE_MDX_DIRECTIVE_NAME;
  },
  Editor: YouTubeMdxDirectiveEditor,
  hasChildren: false,
  attributes: [],
};
